import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Dates = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  
  color: rgba(137, 121, 110, 1);
  margin-bottom: 16px;
`

export const StyledText = styled.div<{isImageCaption?: boolean}>`
  line-height: 120%;
  white-space: pre-wrap;

  font-size: ${({ isImageCaption }) => (isImageCaption ? '24px' : '16px')};
  font-weight: ${({ isImageCaption }) => (isImageCaption ? '600' : '400')};
  text-align: ${({ isImageCaption }) => (isImageCaption ? 'center' : 'left')};
  font-family: ${({ isImageCaption }) => (isImageCaption ? 'Cormorant, sans-serif' : 'Inter, sans-serif')};

  margin-bottom: 36px;
  color: rgba(57, 29, 10, 1);
`

export const ImagesWrapper = styled.div`
  margin-bottom: 16px;
`
